import React from 'react'
import { connect } from 'react-redux'
import ContactUsModal from '../../components/ContactUsModal/ContactUsModal'
import { selectContactOptions, selectDisplayComponent } from './selectors'
import { selectFootprintId } from '../UserEvents/selectors'
import { createEvent, createFootprint } from '../UserEvents/actions'
import { updateDisplayComponent } from './actions'
import { OptionsHOC } from '../../hocs'

const ContactUsModalContainer = ({
  contactOptions,
  show,
  onHide,
  createUserEvent,
  help,
  preSaleFlag,
  createFootprint,
  updateDisplayComponent,
  displayComponent,
  footprintId,
  getOption
}) => {
  const defaultContactOptions = [
    {
      button_text: 'Email',
      contact_text: getOption('moreHelpFooter.contactEmail'),
      link_location: null,
      presales: 0
    },
    {
      button_text: 'Phone',
      contact_text: getOption('.moreHelpFooter.contactPhone'),
      link_location: null,
      presales: 0
    }
  ]

  return (
    <ContactUsModal
      showAll={getOption('contact.showAlways')}
      contactOptions={
        contactOptions.length > 0 ? contactOptions : defaultContactOptions
      }
      show={show}
      onHide={onHide}
      createUserEvent={createUserEvent}
      help={help}
      preSaleFlag={preSaleFlag}
      updateDisplayComponent={updateDisplayComponent}
      displayComponent={displayComponent}
      createFootprint={createFootprint}
      footprintId={footprintId}
      contactConfig={getOption('contact.introText')}
    />
  )
}

const mapStateToProps = state => ({
  contactOptions: selectContactOptions(state),
  displayComponent: selectDisplayComponent(state),
  footprintId: selectFootprintId(state)
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event)),
  createFootprint: contact => dispatch(createFootprint.request(contact)),
  updateDisplayComponent: component =>
    dispatch(updateDisplayComponent(component))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsHOC(ContactUsModalContainer))



// WEBPACK FOOTER //
// ./src/containers/ContactUsModal/ContactUsModal.js